const API_BASE_URL = process.env.API_BASE_URL;
const lang = $('html').attr('lang');


function intersect(a, b) {
  var setA = new Set(a);
  var setB = new Set(b);
  var intersection = new Set([...setA].filter(x => setB.has(x)));
  return Array.from(intersection);
}

// Vue.use(Lightbox);

Vue.component('select2', {
  name: 'Select2',
  props: ['options', 'value'],
  template: '<select class="select select_check"><slot></slot></select>',
  mounted: function() {
    var vm = this
    $(this.$el)
    .select2({
        minimumResultsForSearch: Infinity,
        data: this.options,
        placeholder: '',
        allowClear: true,
    })
    .val(this.value)
    .trigger('change')
    .on('change', function () {
      vm.$emit('input', this.value)
    })
  },
  watch: {
    value: function (value) {
      $(this.$el)
        .val(value)
        .trigger('change')
    },
    options: function (options) {
      $(this.$el).empty().select2({ data: options })
    }
  },
  destroyed: function () {
    $(this.$el).off().select2('destroy')
  },
  
})

var app = new Vue({
    el: '#sell',
    data: {
        categories: [],
        rootCategory: null,
        selectedCategory: null,
        selectedCategories: [],
        vehicles: [],
        search: '',
        scrolled: false,
        // lightboxImages: [],
        thumbnailDir: '/media/vehicles/',
    },
    delimiters: ['<%','%>'],
    mounted() {
        axios
            .get(API_BASE_URL + 'vehicle-categories/?format=json&lang=' + lang)
            .then(
                response => {
                    this.categories = response.data
                    for(let category of this.categories) {
                        if(category.is_root) {
                            this.selectedCategories.push(category.id);
                            this.rootCategory = category;
                        }   
                    }
                    // if(this.categories.length > 0) {
                    //     this.selectedCategories.push(this.categories[0].id);
                    // }
                }
            );
        axios
            .get(API_BASE_URL + 'vehicles/?format=json&lang=' + lang)
            .then(
                response => {
                    this.vehicles = response.data
                }
            );
    },
    methods: {
        filterCategory: function (categoryId) {
            for(let category of this.categories) {
                if(category.id == categoryId) {
                    this.selectedCategory = categoryId;
                }
            }
        },
        selectCategory: function(categoryId) {
            if(this.rootCategory && this.rootCategory.id == categoryId) {
                this.selectedCategories = [this.rootCategory.id];
            } else {
                this.selectedCategories = this.selectedCategories.filter(
                    item => this.rootCategory && item !== this.rootCategory.id
                );
                if(this.selectedCategories.includes(categoryId)) {
                    this.selectedCategories = this.selectedCategories.filter(
                        item => item !== categoryId
                    );
                } else {
                    this.selectedCategories.push(categoryId);
                }
            }
            if(!this.scrolled) {
                $('html, body').animate(
                    {
                        scrollTop: $('#sell').offset().top - 50
                    }, 500
                );
                this.scrolled = true;
            }
        },
        // showLightbox: function(vehicle) {
        //     this.lightboxImages = vehicle.images.map(
        //         image => {
        //             return {
        //                 'name': image
        //             }
        //         }
        //     );
        //     if(this.lightboxImages.length > 0) {
        //         this.$refs.lightbox.show(this.lightboxImages[0].name);
        //     }
        // }
    },
    computed: {
        selectedVehicles: function() {
            let vehicles = this.vehicles.filter(
                vehicle => intersect(vehicle.categories, this.selectedCategories).length > 0
            );
            if(this.search) {
                vehicles = vehicles.filter(
                    vehicle => vehicle.name.toLowerCase().includes(this.search.toLowerCase()));
            }
            return vehicles;
        },
    },
});

$('.select').on('change',function(){
    let data = $(this).select2('data');
    app.selectedCategories = [];
    for(let element of data) {
        app.selectCategory(parseInt(element.id));
        // if($(element.element).data('root') && data.length > 1) {
        //     $('.select2-search-choice:eq(0)').hide();
        //     $('.select2-result-selectable:eq(0)').removeClass('select2-selected');

        // } else {
        //     app.selectCategory(parseInt(element.id));
        // }
    }
});



// WEBPACK FOOTER //
// ./js/pages/sell.js